/**
 * Auth event names. Virtual-web emits SESSION_INVALID when validate fails (401/404);
 * host should refresh auth and clear session. CHANGED is no longer used by virtual-web
 * (embedded session comes from host props only).
 */
export const AUTH_EVENTS = {
  SESSION_INVALID: 'c7:auth:session-invalid',
} as const;
